export default __webpack_public_path__ + "static/media/users.32dcff7c.csv";